import { cn } from '../../lib/cn.ts';
import { pillLabelBreakpoint } from './pill-label-breakpoint.ts';

export interface PillLabelProps {
  label: string;
  short: string;
  /* What the pill sets around its text — padding, border, icon — in rem. */
  chromeRem: number;
}

/**
 * A pill's text that says less when the card it sits on has no room for all
 * of it. The card's pill slot is the `pill` container it measures. A screen
 * reader always gets the full label; if even that estimate falls short, the
 * full label ends in "…" rather than leave the card.
 */
export function PillLabel({ label, short, chromeRem }: PillLabelProps) {
  const breakpoint = pillLabelBreakpoint(label, chromeRem);

  return (
    <>
      <span data-slot='pill-label' className={cn('truncate', breakpoint.label)}>
        {label}
      </span>
      <span
        data-slot='pill-label-short'
        aria-hidden='true'
        className={cn('hidden truncate', breakpoint.short)}
      >
        {short}
      </span>
    </>
  );
}
